import React from 'react';

export default function Testimonials() {
    return (
        <section className="testimonials-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-5">
                        <div className="section-title-s4">
                            <div className="icon">
                                <i className="fi flaticon-blocks-with-angled-cuts"></i>
                            </div>
                            <span>Testimonials</span>
                            <h2>What our Clients say About us</h2>
                            <p>Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nuncIt showed a lady fitted out</p>
                        </div>
                    </div>
                    <div className="col col-lg-7">
                        <div className="testimonials-grids testimonials-slider owl-carousel owl-theme">
                            <div className="grid">
                                <i className="fi flaticon-left-quote"></i>
                                <p>Recently cut out of an illustrated magazine and housed in a nice, gilded frame. It showed a lady fitted out with a fur hat and</p>
                                <div className="client-info">
                                    <div className="img-holder">
                                        <img src="assets/images/testimonials/img-1.jpg" alt="" />
                                    </div>
                                    <h3>Michel Jone</h3>
                                    <span>Creative Designer</span>
                                </div>
                            </div>
                            <div className="grid">
                                <i className="fi flaticon-left-quote"></i>
                                <p>Recently cut out of an illustrated magazine and housed in a nice, gilded frame. It showed a lady fitted out with a fur hat and</p>
                                <div className="client-info">
                                    <div className="img-holder">
                                        <img src="assets/images/testimonials/img-2.jpg" alt="" />
                                    </div>
                                    <h3>Michel Jone</h3>
                                    <span>Creative Designer</span>
                                </div>
                            </div>
                            <div className="grid">
                                <i className="fi flaticon-left-quote"></i>
                                <p>Recently cut out of an illustrated magazine and housed in a nice, gilded frame. It showed a lady fitted out with a fur hat and</p>
                                <div className="client-info">
                                    <div className="img-holder">
                                        <img src="assets/images/testimonials/img-1.jpg" alt="" />
                                    </div>
                                    <h3>Michel Jone</h3>
                                    <span>Creative Designer</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}